import { Department } from '@/entities/Department/Department'
import { DepartmentResource } from '@/models'

export const transformLegacyDepartmentToDepartment = (resource: DepartmentResource): Department => ({
    id: resource.id,
    name: resource.name,
})
